<app-currency-general-filters [filter]="filter"></app-currency-general-filters>

<app-favourite-currency-filters [filter]="filter" [activeRules]="activeRules" [activeSpecialRules]="activeSpecialRules"></app-favourite-currency-filters>

<div class="filter-group" data-group-visibility-id="showCurrencyFilters">
<div class="filter-group-header">
  <div class="filter">
    <span class="input-group-btn">
      <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showCurrencyFilters" (click)="filter.groupVisibility.showCurrencyFilters = !filter.groupVisibility.showCurrencyFilters; updateFilter()"></button>
    </span>
    <span class="filter-body">
      <span filter-title text="Hide Currency" [activeRules]="activeRules.currencyFilters">
        Hiding Currency through any of these filters will force them to be displayed as F-Tier, which is hidden by default.
        @if (filter.tierCosmetics.length >= 7 && filter.tierCosmetics[6].displayOptions.hidden === false) {
          <br />
          <br />Warning! Your F-Tier Cosmetics are not set as hidden, so you will still see these items.
        }
        <br />
        <br />Stacks of {{ filter.cosmeticSettings.stackedGeneralCurrencyOneTierThreshold || 3 }} or more of these hidden currencies will still be shown, stacks of {{ filter.cosmeticSettings.stackedGeneralCurrencyTwoTiersThreshold || 10 }} or more will be highlighted as D-Tier.
        <br />
        <br />You can configure these thresholds in the 'Currency Stack Settings' section below.
      </span>
    </span>
  </div>
</div>
@if (navigationEnabled || filter.groupVisibility.showCurrencyFilters) {
  <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showCurrencyFilters">

    <div class="filter filter-property full-span" [class.disabled]="!filter.hideScrolls && !filter.hidePortalScrolls">
      <span class="input-group-btn">
        <button class="btn toggle-btn" [class.off]="!filter.hideScrolls" (click)="toggleHideScrolls(); rebuildCurrencyTiers()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="{{ poe1 && isMobile() ? 'Hide Scrolls' : 'Hide Scrolls of Wisdom' }}" ruleId="currency">
          @if (poe1) {
            Stacks of {{ filter.cosmeticSettings.stackedGeneralCurrencyOneTierThreshold || 3 }} or more will still be shown and stacks of {{ filter.cosmeticSettings.stackedGeneralCurrencyTwoTiersThreshold || 10 }} or more will still be highlighted by default. If you specify a maximum amount, stacks below that amount will always be hidden.
            <br />
            <br />You can configure this behaviour further in the 'Currency Stack Settings' section below.
          }
        </span>
      </span>
      @if (poe1) {
        <span class="sep"></span>
        <input type="number" placeholder="≤ Amt" maxlength="1" pattern="[0-9]" inputmode="numeric" step="any" class="form-control minmax"
          [disabled]="!filter.hideScrolls" [(ngModel)]="filter.hideScrollsLowerThan" (change)="updateFilter()">
        <span class="sep"></span>
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.hidePortalScrolls" (click)="toggleHidePortalScrolls(); rebuildCurrencyTiers()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ isMobile() ? 'Hide Portals' : 'Hide Portal Scrolls' }}" ruleId="currency">
            Stacks of {{ filter.cosmeticSettings.stackedGeneralCurrencyOneTierThreshold || 3 }} or more will still be shown and stacks of {{ filter.cosmeticSettings.stackedGeneralCurrencyTwoTiersThreshold || 10 }} or more will still be highlighted by default. If you specify a maximum amount, stacks below that amount will always be hidden.
            <br />
            <br />You can configure this behaviour further in the 'Currency Stack Settings' section below.
          </span>
        </span>
        <span class="sep"></span>
        <input type="number" placeholder="≤ Amt" maxlength="1" pattern="[0-9]" inputmode="numeric" step="any" class="form-control minmax"
          [disabled]="!filter.hidePortalScrolls" [(ngModel)]="filter.hidePortalScrollsLowerThan" (change)="updateFilter()">
      }
    </div>

    <div class="filter filter-property full-span" [class.disabled]="!filter.hideCurrency">
      <span class="input-group-btn">
        <button class="btn toggle-btn" [class.off]="!filter.hideCurrency" (click)="toggleHideCurrency(); rebuildCurrencyTiers();"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Hide Currency" ruleId="currency">
          On the <a href="/tier-list/currency">Currency Tier List</a> tab you can specify in detail which currency belongs to which tier,
          and on the <a href="/cosmetic/currency">Currency Cosmetics</a> tab you can specify how items in that tier should be displayed.
        </span>
        <span class="sep"></span>
        <app-autocomplete
          [allLabel]="'None'"
          [options]="cheapCurrencyWithImages"
          [disabled]="!filter.hideCurrency"
          [showOptions]="true"
          [selectedValues]="filter.hideCurrencyTypes"
          (selectedValuesChange)="filter.hideCurrencyTypes = $event; rebuildCurrencyTiers();"></app-autocomplete>
      </span>
    </div>

    <div class="filter filter-property full-span" [class.disabled-filter-property-container]="filter.showLevelingGold" [class.disabled]="filter.showLevelingGold">
      <span class="input-group-btn">
        <button class="btn toggle-btn" [class.off]="!filter.hideGold" (click)="toggleHideGold()" [disabled]="filter.showLevelingGold"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Hide Gold {{ isMobile() ? '' : 'Stacks' }}" [ruleIds]="['gold-hide-small', 'gold-normal-stacks', 'gold-large-stacks', 'gold-huge-stacks']" [class.disabled]="!filter.hideGold">
        </span>
        @if (!isMobile()) {
          <span class="sep"></span>
          <div class="filter-title filter-label" [class.disabled]="!filter.hideGold">
            <span class="filter-title-text">≤</span>
          </div>
        }
        <span class="sep"></span>
        <input type="number" placeholder="min" maxlength="4" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.width]="!isMobile() ? '64px' : '40px'" [style.min-width]="!isMobile() ? '64px' : '40px'"
          [disabled]="!filter.hideGold" [(ngModel)]="filter.hideGoldLowerThan" (change)="goldLowerThanChanged()">
        <span class="sep"></span>
        <div class="filter-title filter-label table-checkbox-group" [class.standalone]="isMobile()">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showLargeGoldStacks" (click)="toggleShowLargeGoldStacks()"></button>
          </span>
          @if (!isMobile()) {
            <div class="table-checkbox-label">
                <span class="filter-title-text">≥</span>
            </div>
          }
        </div>
        <span class="sep"></span>
        <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
          [disabled]="!filter.showLargeGoldStacks"
          [(ngModel)]="filter.showLargeGoldStacksMinStackSize" (keyup)="showLargeGoldStacksMinStackSizeChanged()">
        <span class="sep"></span>
        <div class="filter-title filter-label">
          <app-equipment-tier-picker
            [standalone]="true"
            [equipmentType]="EquipmentType.LargeGoldStacks"
            [active]="filter.showLargeGoldStacks"
            [exampleName]="'Gold'"
            [stackSize]="filter.showLargeGoldStacksMinStackSize"></app-equipment-tier-picker>
        </div>
        <span class="sep"></span>
        <div class="filter-title filter-label table-checkbox-group" [class.standalone]="isMobile()">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showHugeGoldStacks" (click)="toggleShowHugeGoldStacks()"></button>
          </span>
          @if (!isMobile()) {
            <div class="table-checkbox-label">
              <span class="filter-title-text">≥</span>
            </div>
          }
        </div>
        <span class="sep"></span>
        <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
          [disabled]="!filter.showHugeGoldStacks"
          [(ngModel)]="filter.showHugeGoldStacksMinStackSize" (keyup)="showHugeGoldStacksMinStackSizeChanged()">
        <span class="sep"></span>
        <div class="filter-title filter-label">
          <app-equipment-tier-picker
            [standalone]="true"
            [equipmentType]="EquipmentType.HugeGoldStacks"
            [active]="filter.showHugeGoldStacks"
            [exampleName]="'Gold'"
            [stackSize]="filter.showHugeGoldStacksMinStackSize"></app-equipment-tier-picker>
        </div>
      </span>

      @if (filter.showLevelingGold) {
        <div class="disabled-filter-property" (click)="navigateToLevelingGold()">
          Managed by <strong>Leveling Gold</strong> settings.
        </div>
      }
    </div>

    @if (poe2) {
      <div class="filter filter-property full-span" [class.disabled-filter-property-container]="filter.showLevelingVerisium" [class.disabled]="filter.showLevelingVerisium">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.hideVerisium" (click)="toggleHideVerisium()" [disabled]="filter.showLevelingVerisium"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Hide Verisium {{ isMobile() ? '' : 'Stacks' }}" [ruleIds]="['verisium-hide-small', 'verisium-normal-stacks', 'verisium-large-stacks', 'verisium-huge-stacks']" [class.disabled]="!filter.hideVerisium">
          </span>
          @if (!isMobile()) {
            <span class="sep"></span>
            <div class="filter-title filter-label" [class.disabled]="!filter.hideVerisium">
              <span class="filter-title-text">≤</span>
            </div>
          }
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="4" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.width]="!isMobile() ? '64px' : '40px'" [style.min-width]="!isMobile() ? '64px' : '40px'"
            [disabled]="!filter.hideVerisium" [(ngModel)]="filter.hideVerisiumLowerThan" (change)="verisiumLowerThanChanged()">
          <span class="sep"></span>
          <div class="filter-title filter-label table-checkbox-group" [class.standalone]="isMobile()">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!filter.showLargeVerisiumStacks" (click)="toggleShowLargeVerisiumStacks()"></button>
            </span>
            @if (!isMobile()) {
              <div class="table-checkbox-label">
                  <span class="filter-title-text">≥</span>
              </div>
            }
          </div>
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showLargeVerisiumStacks"
            [(ngModel)]="filter.showLargeVerisiumStacksMinStackSize" (keyup)="showLargeVerisiumStacksMinStackSizeChanged()">
          <span class="sep"></span>
          <div class="filter-title filter-label">
            <app-equipment-tier-picker
              [standalone]="true"
              [isCurrency]="true"
              [equipmentType]="EquipmentType.LargeVerisiumStacks"
              [active]="filter.showLargeVerisiumStacks"
              [exampleName]="'Verisium'"
              [stackSize]="filter.showLargeVerisiumStacksMinStackSize"></app-equipment-tier-picker>
          </div>
          <span class="sep"></span>
          <div class="filter-title filter-label table-checkbox-group" [class.standalone]="isMobile()">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!filter.showHugeVerisiumStacks" (click)="toggleShowHugeVerisiumStacks()"></button>
            </span>
            @if (!isMobile()) {
              <div class="table-checkbox-label">
                <span class="filter-title-text">≥</span>
              </div>
            }
          </div>
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showHugeVerisiumStacks"
            [(ngModel)]="filter.showHugeVerisiumStacksMinStackSize" (keyup)="showHugeVerisiumStacksMinStackSizeChanged()">
          <span class="sep"></span>
          <div class="filter-title filter-label">
            <app-equipment-tier-picker
              [standalone]="true"
              [isCurrency]="true"
              [equipmentType]="EquipmentType.HugeVerisiumStacks"
              [active]="filter.showHugeVerisiumStacks"
              [exampleName]="'Verisium'"
              [stackSize]="filter.showHugeVerisiumStacksMinStackSize"></app-equipment-tier-picker>
          </div>
        </span>

        @if (filter.showLevelingVerisium) {
          <div class="disabled-filter-property" (click)="navigateToLevelingVerisium()">
            Managed by <strong>Leveling Verisium</strong> settings.
          </div>
        }
      </div>
    }

    @if (poe2) {
      <div class="filter filter-property full-span" [class.disabled]="!filter.hideRegularRunes">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.hideRegularRunes" (click)="toggleHideRegularRunes(); rebuildCurrencyTiers()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Hide Regular Runes" ruleId="currency">
            Hides all Regular (Tiered) Runes (Lesser, Normal and Greater).
          </span>
          <span class="sep"></span>
          <div class="filter-title filter-label">
            Except
          </div>
          <span class="sep"></span>
          <app-autocomplete
            [allLabel]="'None'"
            [options]="runeBaseTypes"
            [disabled]="!filter.hideRegularRunes"
            [showOptions]="true"
            [selectedValues]="filter.hideRegularRunesExceptions"
            (selectedValuesChange)="filter.hideRegularRunesExceptions = $event; rebuildCurrencyTiers();"></app-autocomplete>
        </span>
      </div>

      <div class="filter full-span" [class.disabled]="!filter.hideUncutGems">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.hideUncutGems" (click)="toggleHideUncutGems(); rebuildCurrencyTiers()"></button>
        </span>
        <span class="filter-body" [class.disabled]="!filter.hideUncutGems">
          <span filter-title text="{{ isMobile() ? 'Hide Gems' : 'Hide Uncut Gems' }}" ruleId="currency">
            Uncut Skill, Spirit and Support gems are tiered by their value. Here you can easily specify to hide gems of and below a certain level. The level specified is the maximum level that will be hidden. Leave an input field empty to not hide gems of that type.
          </span>
          <span class="sep"></span>
          <div class="filter-title filter-label">
            <app-tooltip-wrapper>
              <img src="{{ assetBaseUrl }}/img/currency/UncutSkillGem.webp" style="width: 16px; height: 16px;"> ≤
              <ng-template #tooltip>
                Hide <span class="currency-color">Uncut Skill Gem</span>s of level {{ filter.hideUncutSkillGemsBelowLevel }} and below.
              </ng-template>
            </app-tooltip-wrapper>
          </div>
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" min="1" max="20" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.hideUncutGems" [(ngModel)]="filter.hideUncutSkillGemsBelowLevel" (change)="updateHideUncutSkillGems(); rebuildCurrencyTiers()">
          <span class="sep"></span>
          <div class="filter-title filter-label">
            <app-tooltip-wrapper [right]="true">
              <img src="{{ assetBaseUrl }}/img/currency/UncutSkillGemBuff.webp" style="width: 16px; height: 16px;"> ≤
              <ng-template #tooltip>
                Hide <span class="currency-color">Uncut Spirit Gem</span>s of level {{ filter.hideUncutSpiritGemsBelowLevel }} and below.
              </ng-template>
            </app-tooltip-wrapper>
          </div>
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" min="4" max="20" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.hideUncutGems" [(ngModel)]="filter.hideUncutSpiritGemsBelowLevel" (change)="updateHideUncutSpiritGems(); rebuildCurrencyTiers()">
          <span class="sep"></span>
          <div class="filter-title filter-label">
            <app-tooltip-wrapper [right]="true">
              <img src="{{ assetBaseUrl }}/img/currency/UncutSupportGem.webp" style="width: 16px; height: 16px;"> ≤
              <ng-template #tooltip>
                Hide <span class="currency-color">Uncut Support Gem</span>s of level {{ filter.hideUncutSupportGemsBelowLevel }} and below.
              </ng-template>
            </app-tooltip-wrapper>
          </div>
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" min="1" max="5" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.hideUncutGems" [(ngModel)]="filter.hideUncutSupportGemsBelowLevel" (change)="updateHideUncutSupportGems(); rebuildCurrencyTiers()">
        </span>
      </div>
    }

  </div>
  <div class="clear"></div>
}
</div>

<div class="filter-group" data-group-visibility-id="showCurrencyStackSettings">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showCurrencyStackSettings" (click)="filter.groupVisibility.showCurrencyStackSettings = !filter.groupVisibility.showCurrencyStackSettings; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Currency Stack Settings" [activeRules]="activeSpecialRules.currencyStackSettings">
          Here you can specify the thresholds at which stack sizes Currency should move one or two tiers higher.
          @if (poe2) {
            <br /><br />The following currency can drop in stacks and can thus be promoted: {{ stackableCurrency.join(', ') }}.
          }
        </span>
      </span>
    </div>
  </div>

  @if (navigationEnabled || filter.groupVisibility.showCurrencyStackSettings) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showCurrencyStackSettings">
      <div class="filter filter-property full-span" [class.disabled]="!filter.cosmeticSettings.stackedGeneralCurrencyPromotionEnabled">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.cosmeticSettings.stackedGeneralCurrencyPromotionEnabled"
            (click)="toggleStackedGeneralCurrencyPromotion();"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="General Rule" [ruleIds]="['currency-large-stacks', 'currency-small-stacks']"></span>
          <span class="sep"></span>
          <div class="filter-title filter-label">
            <span class="table-checkbox-label">+1 Tier</span>
          </div>
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.cosmeticSettings.stackedGeneralCurrencyPromotionEnabled"
            [(ngModel)]="filter.cosmeticSettings.stackedGeneralCurrencyOneTierThreshold" (change)="updateFilter()">
          <span class="sep"></span>
          <div class="filter-title filter-label">
            <span class="table-checkbox-label">+2 Tiers</span>
          </div>
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.cosmeticSettings.stackedGeneralCurrencyPromotionEnabled"
            [(ngModel)]="filter.cosmeticSettings.stackedGeneralCurrencyTwoTiersThreshold" (change)="updateFilter()">
        </span>
      </div>

      @if (poe1) {
        <div class="filter filter filter-padded-left filter-property" style="width: 100%;" [class.disabled]="!filter.cosmeticSettings.stackedGeneralCurrencyPromotionEnabled">
          <span class="filter-body">
            <span filter-title text="Exclude">
              Stacks of these currencies will never be promoted to a higher tier. If they are hidden, they always will be, regardless of their stack size.
            </span>
            <span class="sep"></span>
            <app-autocomplete
              [allLabel]="'None'"
              [options]="cheapCurrencyWithImages"
              [disabled]="!filter.cosmeticSettings.stackedGeneralCurrencyPromotionEnabled"
              [showOptions]="true"
              [selectedValues]="filter.cosmeticSettings.stackedGeneralCurrencyNeverPromote || ['None']"
              (selectedValuesChange)="filter.cosmeticSettings.stackedGeneralCurrencyNeverPromote = $event; updateFilter();">
            </app-autocomplete>
          </span>
        </div>
      }

      <div class="filter filter-property full-span" [class.disabled]="!filter.cosmeticSettings.stackedHiddenCurrencyPromotionEnabled">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.cosmeticSettings.stackedHiddenCurrencyPromotionEnabled" [disabled]="!filter.cosmeticSettings.stackedGeneralCurrencyPromotionEnabled"
            (click)="filter.cosmeticSettings.stackedHiddenCurrencyPromotionEnabled = !filter.cosmeticSettings.stackedHiddenCurrencyPromotionEnabled; updateFilter();"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Hidden Tiers">
            Here you can apply specific thresholds for currency in Tiers which are hidden.
          </span>
          <span class="sep"></span>
          <div class="filter-title filter-label">
            <span class="table-checkbox-label">+1 Tier</span>
          </div>
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.cosmeticSettings.stackedHiddenCurrencyPromotionEnabled"
            [(ngModel)]="filter.cosmeticSettings.stackedHiddenCurrencyOneTierThreshold" (change)="updateFilter()">
          <span class="sep"></span>
          <div class="filter-title filter-label">
            <span class="table-checkbox-label">+2 Tiers</span>
          </div>
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.cosmeticSettings.stackedHiddenCurrencyPromotionEnabled"
            [(ngModel)]="filter.cosmeticSettings.stackedHiddenCurrencyTwoTiersThreshold" (change)="updateFilter()">
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.cosmeticSettings.stackedHiddenCurrencyNeverHighlight">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.cosmeticSettings.stackedHiddenCurrencyNeverHighlight" [disabled]="!filter.cosmeticSettings.stackedGeneralCurrencyPromotionEnabled"
            (click)="filter.cosmeticSettings.stackedHiddenCurrencyNeverHighlight = !filter.cosmeticSettings.stackedHiddenCurrencyNeverHighlight; updateFilter();"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Never Highlight Stacks of Hidden Currency">
            When stacked Currency from a Hidden tier is promoted to a higher tier, prevent it from receiving a Highlight (beam, minimap icon and sound).
          </span>
        </span>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>
